import * as Adaptive from "adaptivecards";
import { TypedCardElementPeer, PropertySheet, PropertySheetCategory, StringPropertyEditor } from "adaptivecards-designer";
import { removeOtherPropertyConfigurations } from "../Utils/CustomElementUtils";
import { getPropertyEditorInstance, PropertyKeys } from "../Pickers/PickerBase";
import { ICustomProperty } from "../../../shared/interfaces/customproperties.interface";
import { CustomPropertyBase } from "./CustomPropertyBase";
export class TextProperty extends CustomPropertyBase {
    static JsonTypeName;
    static ElementId;
    static defaultLabel;
    static customPropertyData: ICustomProperty;

    constructor(paramType, paramCustomPropertyData: ICustomProperty) {
        
        TextProperty.JsonTypeName = paramType ?? TextProperty.JsonTypeName;
        TextProperty.ElementId = paramCustomPropertyData?.PropertyId ?? TextProperty.ElementId;
        TextProperty.defaultLabel = paramCustomPropertyData?.Name ?? TextProperty.defaultLabel;
        TextProperty.customPropertyData = paramCustomPropertyData ?? TextProperty.customPropertyData;
        
        super();
    }

    internalRender(): HTMLElement | undefined {
        if((this?.id ?? "").length == 0)
            this.id = TextProperty.ElementId;

        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = TextProperty.defaultLabel;

        if((this?.dataType ?? "").length == 0)
            this.dataType = TextProperty.customPropertyData?.DataType ?? "";

        this.requireField ??= TextProperty.customPropertyData?.IsRequired ?? false;

        this.errorMessage ??= TextProperty.customPropertyData?.ErrorMessage ?? "";

        return super.internalRender();
    }

    getJsonTypeName(): string {
        return TextProperty.JsonTypeName;
    }
}

export class TextPropertyPeer extends TypedCardElementPeer<TextProperty> {
    static readonly displayLabelProperty = new StringPropertyEditor(Adaptive.Versions.v1_0, "displayLabel", "Label", false);
    static requireFieldProperty = getPropertyEditorInstance(TextProperty.ElementId, PropertyKeys.requireField);
    static readonly requiredMessageProperty = new StringPropertyEditor(Adaptive.Versions.v1_0, "errorMessage", "Error Message", false);

    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);

        propertySheet.add(
            defaultCategory,
            TextPropertyPeer.idProperty,
            TextPropertyPeer.displayLabelProperty
        );

        propertySheet.add(
            "Validation",            
            TextPropertyPeer.requireFieldProperty,
            TextPropertyPeer.requiredMessageProperty
        );
    }
}